var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SelectObjectStore,{attrs:{"for-what":_setup.newDatasetsDescription,"selected-object-store-id":_setup.selectedObjectStoreId,"default-option-title":_setup.defaultOptionTitle,"default-option-description":_setup.defaultOptionDescription},on:{"onSubmit":_setup.handleSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }